import { useHandlers } from '../../../context/page-context';
import type { CustomersApiContract } from '../api';

export function useCustomersApi(): { customersApi: CustomersApiContract } {
  const { apis } = useHandlers();
  return { customersApi: apis.customers };
}
